module.exports = __webpack_public_path__ + "static/services-graphic-7-59c1fe36191951d67f55a5ba4e3d26ee.svg";